/*
 * @Author: your name
 * @Date: 2020-08-02 22:17:21
 * @LastEditTime: 2020-08-02 22:17:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/x-user-tag/index.js
 */ 
import XUserTag from './x-user-tag'

XUserTag.install = (vue) => {
  vue.component(XUserTag.name, XUserTag)
}

export default XUserTag